export enum GameTypesEnum {
  Basic = 'basic',
  Featured = 'featured',
  PlayAgain = 'play_again',
  NewGames = 'new_games',
  Top5 = 'top_5',
  Recommended = 'recommended',
  BecauseYouPlayed = 'because_you_played',
  Provider = 'provider',
  BecauseYouPlayedFromCurrentGame = 'because_you_played_from_current_game',
  ProviderFromCurrentGame = 'provider_from_current_game',
  Favorites = 'favorites',
  Jackpots = 'jackpots',
  TableGames = 'table_games',
  LiveGames = 'live_games',
  Megaways = 'megaways',
  Slots = 'slots',
  Fun = 'fun',
  Popular = 'all',
  StickyWilds = 'sticky_wilds',
  Providers = 'prodiders',
  MustGoJackpots = 'must_go_jackpots',
  DropsAndWins = 'drops_and_wins'
}

export interface GameConfig {
  playBtn: boolean;
  infoBtn: boolean;
  browseAll: boolean;
  browseAllLink?: string;
  ranking: boolean;
  min_width: number;
  ideal_width: number;
  max_width: number;
  spacer: number;
  every: number;
}

export interface SingleGameConfig {
  title: string;
  config: GameConfig;
}

export interface SliderGamesConfig {
  jackpots: string[];
  megaways: string[];
  newToSkol: string[];
  liveGames: string[];
  tableGames: string [];
}

export type GamesSlidersConfig = {
  [key in GameTypesEnum]: SingleGameConfig;
};
